import { render, staticRenderFns } from "./Setores.vue?vue&type=template&id=3f871b60&scoped=true&"
import script from "./Setores.vue?vue&type=script&lang=js&"
export * from "./Setores.vue?vue&type=script&lang=js&"
import style0 from "./Setores.vue?vue&type=style&index=0&id=3f871b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f871b60",
  null
  
)

export default component.exports